export const colorParse = (color) => {
    let r, g, b;

	if (color.match(/^rgb/)) {
		// If RGB --> store the red, green, blue values in separate variables
		color = color.match(
			/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
		);

		r = color[1];
		g = color[2];
		b = color[3];
	} else {
		// If hex --> Convert it to RGB: http://gist.github.com/983661
		color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

		r = color >> 16;
		g = (color >> 8) & 255;
		b = color & 255;
	}

	return { r, g, b };
};

export const colorShade = (color, percent) => {
	const { r, g, b } = colorParse(color);
	const algorithm = (colorpart) => parseInt((colorpart * (100 + percent)) / 100);
	const hexing = (colorpart) => colorpart.toString(16);
	const R = hexing(Math.min(algorithm(r), 255));
	const G = hexing(Math.min(algorithm(g), 255));
	const B = hexing(Math.min(algorithm(b), 255));
	const RR = R.length === 1 ? '0' + R : R;
	const GG = G.length === 1 ? '0' + G : G;
    const BB = B.length === 1 ? '0' + B : B;
    
	return '#' + RR + GG + BB;
};

export const isColorDark = (color, returnHsp) => {
    const { r, g, b } = colorParse(color);
    const hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
        );
    return returnHsp ? hsp : hsp < 150
}